import React, { useState } from 'react';
import PortingsView from './PortingsView';
import Sellers from './Sellers';
import Businesses from './Businesses';

// Comisiones oculto temporalmente (a solicitud). El componente sigue en
// ./Commissions.js y el endpoint del backend permanece activo.
function isSuperAdmin(user) {
  return user?.role === 'SUPER_ADMIN' || user?.role === 'ADMIN';
}

function Dashboard({ user, onLogout }) {
  const superAdmin = isSuperAdmin(user);
  const nav = [
    { key: 'portings', label: 'Portaciones' },
    { key: 'sellers', label: 'Vendedores' },
    ...(superAdmin ? [{ key: 'businesses', label: 'Negocios' }] : []),
  ];
  const [view, setView] = useState('portings');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    onLogout();
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="header-left">
          <h1>OW App Manager</h1>
          <nav className="header-nav">
            {nav.map((n) => (
              <button
                key={n.key}
                className={`nav-tab ${view === n.key ? 'active' : ''}`}
                onClick={() => setView(n.key)}
              >
                {n.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="header-right">
          {!superAdmin && user?.businessName && (
            <span className="user-business">{user.businessName}</span>
          )}
          <span className="user-name">{user?.name || user?.email || 'Admin'}</span>
          <button className="logout-button" onClick={handleLogout}>
            Cerrar Sesion
          </button>
        </div>
      </header>

      <main className="dashboard-content">
        {view === 'portings' && <PortingsView user={user} />}
        {view === 'sellers' && <Sellers user={user} />}
        {view === 'businesses' && superAdmin && <Businesses />}
      </main>
    </div>
  );
}

export default Dashboard;
